export function createGrant(grantIntent, workflowSessionId) {
    return $.ajax({
        url: `${secureBaseURL}donors/daf-giving-hub/createGrant?workflowSessionId=${workflowSessionId}`,
        type: 'POST',
        data: JSON.stringify(grantIntent),
        contentType: 'application/json',
        // withCredentials is necessary to pass cookies, since this is a cross-origin request
        xhrFields: { withCredentials: true },
    });
}

export function saveUnintegratedGrant(unintegratedGrant) {
    return $.ajax({
        url: `${secureBaseURL}donors/daf-giving-hub/saveUnintegratedGrant`,
        type: 'POST',
        data: JSON.stringify(unintegratedGrant),
        contentType: 'application/json',
        // withCredentials is necessary to pass cookies, since this is a cross-origin request
        xhrFields: { withCredentials: true },
    });
}

export function saveThankYouDetails(thankYouVO) {
    return $.ajax({
        url: `${secureBaseURL}donors/daf-giving-hub/saveThankYouDetails`,
        type: 'POST',
        data: JSON.stringify(thankYouVO),
        contentType: 'application/json',
        // withCredentials is necessary to pass cookies, since this is a cross-origin request
        xhrFields: { withCredentials: true },
    });
}

export function sendExitReason(debugInfo, workflowSessionId) {
    return $.ajax({
        url: `${secureBaseURL}donors/daf-giving-hub/exitReason?workflowSessionId=${workflowSessionId}`,
        type: 'POST',
        data: JSON.stringify(debugInfo),
        contentType: 'application/json',
        // withCredentials is necessary to pass cookies, since this is a cross-origin request
        xhrFields: { withCredentials: true },
    });
}
